import React, { useEffect } from 'react';
import { Loader, hasPartsBasket } from '@triumph/shared';
import { initialisedSelector } from 'src/redux/app/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { setBasepath, setBasketSumary, setBasketItems, setData, setError, setInitialised } from 'src/redux/app/actions';
import getBasket from 'src/requests/getBasket';
import getContent from 'src/requests/getContent';

const Init = ({ basepath, children, contentDataSourceId }) => {
  const initialised = useSelector(initialisedSelector);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      const { data } = await getContent(contentDataSourceId);
      dispatch(setData(data));
      dispatch(setBasepath(basepath));
      dispatch(setInitialised());
    } catch (exception) {
      dispatch(setError(exception));
      throw exception;
    }
  };

  const fetchBasket = async () => {
    if (!hasPartsBasket()) {
      return;
    }

    try {
      const {
        data: { OrderLines: basketItems, ...basketSummary },
      } = await getBasket();

      dispatch(setBasketItems(basketItems));
      dispatch(setBasketSumary(basketSummary));
    } catch (exception) {
      dispatch(setError(exception));
      throw exception;
    }
  };

  useEffect(() => {
    fetchData();
    fetchBasket();
  }, []);

  if (!initialised) {
    return <Loader />;
  }

  return children;
};

export default Init;
